import React from 'react';

interface ChallengesShellProps {
  children: React.ReactNode;
}

/**
 * ChallengesView now owns the full page structure:
 *
 * RoddoPageShell
 *   RoddoSecondaryHeader
 *   RoddoSectionCard
 *     content
 *
 * Keep this shell minimal to avoid nested wrappers/cards.
 */
const ChallengesShell: React.FC<ChallengesShellProps> = ({ children }) => {
  return <>{children}</>;
};

export default ChallengesShell;